// Getting Started
import Vue from 'vue'
import router from './router'
import GettingStarted from './index.vue'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

const gettingStarted = new Vue({
    router,
    render: h => h(GettingStarted),
}).$mount('#getting-started');